export default {
  title: 'Error Logs',
  cleanupOld: 'Cleanup Old',
  refresh: 'Refresh',
  selected: 'selected',
  markResolved: 'Mark Resolved',
  markOpen: 'Mark Open',
  clear: 'Clear',
  startDate: 'Start Date',
  endDate: 'End Date',
  errorType: 'Error Type',
  status: 'Status',
  searchPlaceholder: 'Search message or user',
  type: 'Type',
  message: 'Message',
  user: 'User',
  timestamp: 'Timestamp',
  anonymous: 'Anonymous',
  resolved: 'Resolved',
  open: 'Open',
  errorDetails: 'Error Details',
  errorName: 'Error Name',
  url: 'URL',
  route: 'Route',
  unknown: 'Unknown',
  userAgent: 'User Agent',
  resolvedAt: 'Resolved At',
  context: 'Context',
  stackTrace: 'Stack Trace',
  noErrorLogs: 'No error logs found',
  cleanupOldErrors: 'Cleanup Old Errors',
  cleanupMessage: 'This will permanently delete error logs older than {days} days.',
  daysToKeep: 'Days to keep',
  cancel: 'Cancel',
  delete: 'Delete',
  javascript: 'JavaScript',
  vue: 'Vue',
  promise: 'Promise',
  manual: 'Manual',
  warning: 'Warning',
  info: 'Info',
  failedToLoadLogs: 'Failed to load error logs',
  errorMarkedAs: 'Error marked as {status}',
  failedToUpdateStatus: 'Failed to update error status',
  noErrorsSelected: 'No errors selected',
  errorsMarkedAs: '{count} errors marked as {status}',
  failedBulkUpdate: 'Failed to bulk update errors',
  deletedOldLogs: 'Deleted {count} old error logs',
  failedCleanup: 'Failed to cleanup old logs'
}
